module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toTop.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/icon/goTop.svg"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73859cd3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/toTop.vue
// module id = 48
// module chunks = 0